export const siteTitle = "Retro Games Slovakia";
